import script from "./UserSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserSettings.vue?vue&type=script&setup=true&lang=ts"

import "./UserSettings.vue?vue&type=style&index=0&id=10e62e81&lang=css"

const __exports__ = script;

export default __exports__